export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ece042c9-c81a-4391-a5bf-8fcc2b022067/artifacts/tox2yx3r_IMG_0257.jpeg";

export const APOSTLE_IMAGE =
  "https://customer-assets.emergentagent.com/job_ece042c9-c81a-4391-a5bf-8fcc2b022067/artifacts/9atvjnah_IMG_0258.jpeg";

export const IMAGES = {
  worship:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/kwzuukgz_IMG_0276.jpeg",
  community:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/kwzuukgz_IMG_0276.jpeg",
  bible:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/kql6cy1u_IMG_0259.jpeg",
  gold:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/o43ew3o3_IMG_0264.jpeg",
  crowd:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/1zrhfiuj_IMG_0272.jpeg",
  prayer:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/p5e86a3p_IMG_0263.jpeg",
  hands:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/qcu8qfer_IMG_0262.jpeg",
  preaching:
    "https://customer-assets.emergentagent.com/job_love-breed-church/artifacts/o43ew3o3_IMG_0264.jpeg",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/overseer", label: "Overseer" },
  { to: "/leadership", label: "Leadership" },
  { to: "/ministries", label: "Ministries" },
  { to: "/sermons", label: "Sermons" },
  { to: "/watch-live", label: "Watch Live" },
  { to: "/events", label: "Events" },
  { to: "/devotional", label: "Devotional" },
  { to: "/gallery", label: "Gallery" },
  { to: "/testimonies", label: "Testimonies" },
  { to: "/new-here", label: "New Here?" },
  { to: "/contact", label: "Contact" },
];

export const SOCIALS = [
  { name: "Facebook", url: "https://facebook.com", icon: "Facebook" },
  { name: "YouTube", url: "https://youtube.com", icon: "Youtube" },
  { name: "Instagram", url: "https://instagram.com", icon: "Instagram" },
  { name: "X", url: "https://x.com", icon: "Twitter" },
];
